var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.853027,
    width: 57,
    height: 57,
    rx: 12,
    fill: "#FFF2CF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41846 24.0215L36.981 8.10827V39.9347L9.41846 24.0215Z",
    fill: "#FFF2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7315 22.4475C42.6011 22.1478 42.3894 21.8905 42.1203 21.705C41.8512 21.5194 41.5355 21.4129 41.209 21.3975H33.194L35.4165 13.1025C35.4873 12.8429 35.4973 12.5705 35.4457 12.3065C35.3941 12.0424 35.2823 11.7938 35.119 11.58C34.956 11.3682 34.7466 11.1966 34.507 11.0783C34.2673 10.96 34.0038 10.8982 33.7365 10.8975H21.4865C21.0914 10.884 20.7034 11.0046 20.3856 11.2398C20.0679 11.4749 19.8391 11.8107 19.7365 12.1925L15.0465 29.6925C14.9757 29.9521 14.9657 30.2245 15.0173 30.4885C15.0689 30.7526 15.1807 31.0012 15.344 31.215C15.5088 31.4291 15.721 31.6022 15.9639 31.7206C16.2068 31.839 16.4738 31.8996 16.744 31.8975H23.5165L20.349 43.6925C20.2452 44.0729 20.2729 44.4771 20.4276 44.8397C20.5823 45.2024 20.8549 45.5022 21.2012 45.6905C21.5475 45.8789 21.9473 45.9448 22.3358 45.8775C22.7243 45.8103 23.0786 45.6138 23.3415 45.32L42.4165 24.32C42.6436 24.0713 42.7942 23.7623 42.8501 23.4302C42.9059 23.0981 42.8648 22.7568 42.7315 22.4475ZM25.599 37.6375L27.4715 30.6375C27.5423 30.3779 27.5523 30.1056 27.5007 29.8415C27.4491 29.5774 27.3373 29.3288 27.174 29.115C27.011 28.9032 26.8016 28.7316 26.562 28.6133C26.3223 28.495 26.0588 28.4332 25.7915 28.4325H19.0715L22.8165 14.3975H31.444L29.2215 22.6925C29.1502 22.9569 29.1418 23.2343 29.1972 23.5024C29.2526 23.7706 29.3701 24.022 29.5403 24.2365C29.7105 24.4509 29.9287 24.6225 30.1772 24.7373C30.4258 24.8521 30.6979 24.907 30.9715 24.8975H37.219L25.599 37.6375Z",
    fill: "#0B0A0A"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.35303,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 11.5,
    stroke: "black",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(7.95947 7.39844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.525dd9f8623fd83327fa5df7e6a73983.svg";
export { ForwardRef as ReactComponent };